export default __webpack_public_path__ + "static/media/Restore.0eb3faf1.svg";